import { render, staticRenderFns } from "./BatchDelete.vue?vue&type=template&id=62d923d8"
import script from "./BatchDelete.vue?vue&type=script&lang=js"
export * from "./BatchDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports